// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formBoxStaticText {
  margin: 0px;
  padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/FormBoxStaticText.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;AADF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.formBoxStaticText {\n  margin: 0px;\n  padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
